import React from 'react';
import { FiAlertTriangle, FiCheckCircle, FiInfo, FiXCircle } from 'react-icons/fi';

const iconMap = {
  warning: <FiAlertTriangle className="text-yellow-500 w-6 h-6" />,
  success: <FiCheckCircle className="text-green-500 w-6 h-6" />,
  info: <FiInfo className="text-blue-500 w-6 h-6" />,
  danger: <FiXCircle className="text-red-500 w-6 h-6" />,
};

const ConfirmModal = ({ isOpen, onConfirm, onCancel, message, type = 'info' }) => {
  if (!isOpen) return null;

  const bgColor = {
    warning: 'bg-yellow-100',
    success: 'bg-green-100',
    info: 'bg-blue-100',
    danger: 'bg-red-100',
  }[type];

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 backdrop-blur-sm z-50">
      <div className="bg-white rounded-lg shadow-md max-w-md w-full mx-4">
        <div className={`p-4 flex items-center gap-3 ${bgColor}`}>
          {iconMap[type]}
          <p className="text-gray-800">{message}</p>
        </div>

        <div className="p-4 flex justify-end gap-4 border-t">
          <button
            onClick={onCancel}
            className="bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded text-sm"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className={`px-4 py-2 rounded text-sm text-white ${
              type === 'danger'
                ? 'bg-red-600 hover:bg-red-700'
                : type === 'warning'
                ? 'bg-yellow-500 hover:bg-yellow-600'
                : type === 'success'
                ? 'bg-green-600 hover:bg-green-700'
                : 'bg-blue-600 hover:bg-blue-700'
            }`}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
